/**
 * NEON COACH - Cloudflare R2 Exercise Assets Library
 * 87 Production High-Res Exercise Images
 */

export const R2_EXERCISE_IMAGES = [
  {
    "group": "ارجل",
    "name": "BARBELL BACK SQUAT",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_36%20PM%20%281%29.png"
  },
  {
    "group": "ارجل",
    "name": "DUMBBELL SQUAT",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_36%20PM%20%282%29.png"
  },
  {
    "group": "ارجل",
    "name": "DUMBBELL BULGARIAN SPLIT SQUAT",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_37%20PM%20%283%29.png"
  },
  {
    "group": "ارجل",
    "name": "MACHINE HACK SQUATS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_37%20PM%20%284%29.png"
  },
  {
    "group": "ارجل",
    "name": "SMITH HACK SQUAT ALTERNATIVE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_38%20PM%20%285%29.png"
  },
  {
    "group": "ارجل",
    "name": "SQUAT ALTERNATIVE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_39%20PM%20%286%29.png"
  },
  {
    "group": "ارجل",
    "name": "SQUAT ALTERNATIVE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_40%20PM%20%287%29.png"
  },
  {
    "group": "ارجل",
    "name": "SEATED LEG CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_40%20PM%20%288%29.png"
  },
  {
    "group": "ارجل",
    "name": "LEG PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_40%20PM%20%289%29.png"
  },
  {
    "group": "ارجل",
    "name": "SUMO DEADLIFT",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_41%20PM%20%2810%29.png"
  },
  {
    "group": "ارجل",
    "name": "HIP ADDUCTION MACHINE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_47%20PM%20%281%29.png"
  },
  {
    "group": "ارجل",
    "name": "LEG EXTENSION",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_47%20PM%20%282%29.png"
  },
  {
    "group": "ارجل",
    "name": "BARBELL LUNGE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_48%20PM%20%283%29.png"
  },
  {
    "group": "ارجل",
    "name": "BODYWEIGHT LUNGE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_48%20PM%20%284%29.png"
  },
  {
    "group": "ارجل",
    "name": "STANDING MACHINE CALF RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A7%D8%B1%D8%AC%D9%84/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_55_49%20PM%20%285%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "BARBELL CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%281%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "BARBELL PREACHER CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%282%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "DUMBBELL INCLINE CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%283%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "EZ BARBELL CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%284%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "HAMMER CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%285%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "OVERHEAD CABLE CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%286%29.png"
  },
  {
    "group": "بايسيبس",
    "name": "DUMBBELL CONCENTRATION CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2001_53_54%20AM%20%287%29.png"
  },
  {
    "group": "بطن",
    "name": "PLANK",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%B7%D9%86/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_12_37%20AM%20%281%29.png"
  },
  {
    "group": "بطن",
    "name": "HANGING KNEE RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%B7%D9%86/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_12_38%20AM%20%282%29.png"
  },
  {
    "group": "بطن",
    "name": "MACHINE CRUNCH",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%B7%D9%86/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_12_38%20AM%20%283%29.png"
  },
  {
    "group": "بطن",
    "name": "ABDOMINAL AIR BIKE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%B7%D9%86/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_12_39%20AM%20%284%29.png"
  },
  {
    "group": "بطن",
    "name": "LYING LEG RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%B7%D9%86/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_12_39%20AM%20%285%29.png"
  },
  {
    "group": "بطن",
    "name": "ABDOMINAL REACH",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%A8%D8%B7%D9%86/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_12_41%20AM%20%286%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "CABLE PUSH DOWN",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_34%20AM%20%281%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "CLOSE GRIP BENCH PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_35%20AM%20%282%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "CABLE TRICEP KICKBACK",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_35%20AM%20%283%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "OVERHEAD CABLE ROPE EXTENSION",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_36%20AM%20%284%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "SEATED OVERHEAD DUMBBELL EXTENSION",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_36%20AM%20%285%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "TRICEPS PUSHDOWN WITH REVERSE GRIP",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_37%20AM%20%286%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "PUSHDOWN STRAIGHT BAR TRICEP",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_37%20AM%20%287%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "TRICEP DIPS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_37%20AM%20%288%29.png"
  },
  {
    "group": "ترايسيبس",
    "name": "BAR SKULL CRUSHERS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%AA%D8%B1%D8%A7%D9%8A%D8%B3%D9%8A%D8%A8%D8%B3/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_03_47%20AM.png"
  },
  {
    "group": "سواعد",
    "name": "REVERSE GRIP BARBELL CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_09%20AM%20%281%29.png"
  },
  {
    "group": "سواعد",
    "name": "BARBELL WRIST CURL OVER BENCH",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_10%20AM%20%282%29.png"
  },
  {
    "group": "سواعد",
    "name": "STANDING WRIST CURL BEHIND BACK",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_10%20AM%20%283%29.png"
  },
  {
    "group": "سواعد",
    "name": "SEATED REVERSE BARBELL WRIST CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_11%20AM%20%284%29.png"
  },
  {
    "group": "سواعد",
    "name": "REVERSE GRIP BARBELL CURL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_11%20AM%20%285%29.png"
  },
  {
    "group": "سواعد",
    "name": "CABLE WRIST CURLS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_11%20AM%20%286%29.png"
  },
  {
    "group": "سواعد",
    "name": "BRACHIORADIALIS DUMBBELL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_13%20AM%20%287%29.png"
  },
  {
    "group": "سواعد",
    "name": "REVERSE WRIST CURLS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B3%D9%88%D8%A7%D8%B9%D8%AF/ChatGPT%20Image%20Sep%2015%2C%202026%2C%2012_10_13%20AM%20%288%29.png"
  },
  {
    "group": "صدر",
    "name": "BARBELL BENCH PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_30%20PM%20%281%29.png"
  },
  {
    "group": "صدر",
    "name": "REVERSE GRIP BENCH PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_31%20PM%20%282%29.png"
  },
  {
    "group": "صدر",
    "name": "INCLINE BENCH PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_31%20PM%20%283%29.png"
  },
  {
    "group": "صدر",
    "name": "SMITH MACHINE DECLINE BENCH PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_31%20PM%20%284%29.png"
  },
  {
    "group": "صدر",
    "name": "DUMBBELL BENCH PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_32%20PM%20%285%29.png"
  },
  {
    "group": "صدر",
    "name": "INCLINE DUMBBELL FLY",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_32%20PM%20%286%29.png"
  },
  {
    "group": "صدر",
    "name": "CABLE CROSSOVER",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_33%20PM%20%287%29.png"
  },
  {
    "group": "صدر",
    "name": "PEC DECK FLY",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_33%20PM%20%288%29.png"
  },
  {
    "group": "صدر",
    "name": "DECLINE DUMBBELL FLY",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_33%20PM%20%289%29.png"
  },
  {
    "group": "صدر",
    "name": "DUMBBELL FLY",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B5%D8%AF%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_07_34%20PM%20%2810%29.png"
  },
  {
    "group": "ظهر",
    "name": "REVERSE GRIP BENT OVER ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_10%20PM%20%281%29.png"
  },
  {
    "group": "ظهر",
    "name": "WIDE GRIP LAT PULLDOWN",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%282%29.png"
  },
  {
    "group": "ظهر",
    "name": "RACK PULLS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%283%29.png"
  },
  {
    "group": "ظهر",
    "name": "STRAIGHT ARM CABLE PULLOVER",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%284%29.png"
  },
  {
    "group": "ظهر",
    "name": "HYPEREXTENSION",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%285%29.png"
  },
  {
    "group": "ظهر",
    "name": "T-BAR ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%286%29.png"
  },
  {
    "group": "ظهر",
    "name": "ROMANIAN DEADLIFT",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%287%29.png"
  },
  {
    "group": "ظهر",
    "name": "T-BAR ROW CLOSE GRIP",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%288%29.png"
  },
  {
    "group": "ظهر",
    "name": "TRIPOD DUMBBELL ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%289%29.png"
  },
  {
    "group": "ظهر",
    "name": "TRIPOD DUMBBELL ROW ALTERNATIVE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_11%20PM%20%2810%29.png"
  },
  {
    "group": "ظهر",
    "name": "BENT OVER ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%281%29.png"
  },
  {
    "group": "ظهر",
    "name": "BENT OVER BARBELL ROW ALTERNATIVES",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%282%29.png"
  },
  {
    "group": "ظهر",
    "name": "SEATED CABLE ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%283%29.png"
  },
  {
    "group": "ظهر",
    "name": "REVERSE GRIP LAT PULL DOWN",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%284%29.png"
  },
  {
    "group": "ظهر",
    "name": "SEATED STRAIGHT BAR CABLE ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%285%29.png"
  },
  {
    "group": "ظهر",
    "name": "SEATED CABLE ROW WIDE GRIP",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%286%29.png"
  },
  {
    "group": "ظهر",
    "name": "V-BAR PULLDOWN",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%287%29.png"
  },
  {
    "group": "ظهر",
    "name": "LAT PULL DOWN FRONT ALTERNATIVE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D8%B8%D9%87%D8%B1/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_53_35%20PM%20%288%29.png"
  },
  {
    "group": "كتف",
    "name": "STANDING FACE PULL",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_32%20PM%20%281%29.png"
  },
  {
    "group": "كتف",
    "name": "MACHINE SHOULDER PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_32%20PM%20%282%29.png"
  },
  {
    "group": "كتف",
    "name": "BARBELL SHOULDER PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_32%20PM%20%283%29.png"
  },
  {
    "group": "كتف",
    "name": "SEATED DUMBBELL SHOULDER PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_32%20PM%20%284%29.png"
  },
  {
    "group": "كتف",
    "name": "MACHINE SHOULDER PRESS",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_32%20PM%20%285%29.png"
  },
  {
    "group": "كتف",
    "name": "REVERSE MACHINE FLYES",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_33%20PM%20%286%29.png"
  },
  {
    "group": "كتف",
    "name": "HEAD-ON-BENCH DUMBBELL REAR DELT RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_33%20PM%20%287%29.png"
  },
  {
    "group": "كتف",
    "name": "HIGH CABLE REVERSE FLY",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_33%20PM%20%288%29.png"
  },
  {
    "group": "كتف",
    "name": "BARBELL UPRIGHT ROW",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_33%20PM%20%289%29.png"
  },
  {
    "group": "كتف",
    "name": "STANDING DUMBBELL SHRUG",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_33%20PM%20%2810%29.png"
  },
  {
    "group": "كتف",
    "name": "STANDING BARBELL SHRUG",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_43%20PM%20%281%29.png"
  },
  {
    "group": "كتف",
    "name": "FRONT PLATE RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_43%20PM%20%282%29.png"
  },
  {
    "group": "كتف",
    "name": "DUMBBELL LATERAL RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_44%20PM%20%283%29.png"
  },
  {
    "group": "كتف",
    "name": "CABLE LATERAL RAISE",
    "url": "https://pub-bc14264a47ab413ba995108f257ad83d.r2.dev/GYM.2/%D9%83%D8%AA%D9%81/ChatGPT%20Image%20Sep%2014%2C%202026%2C%2011_54_44%20PM%20%284%29.png"
  }
];

export function getExerciseImageUrl(exerciseName) {
  if (!exerciseName) return null;
  const clean = String(exerciseName).toLowerCase().trim();
  const match = R2_EXERCISE_IMAGES.find(e => 
    e.name.toLowerCase() === clean || 
    clean.includes(e.name.toLowerCase()) || 
    e.name.toLowerCase().includes(clean)
  );
  return match ? match.url : null;
}

export function getExerciseImagesByGroup(groupName) {
  if (!groupName) return [];
  const clean = String(groupName).trim();
  return R2_EXERCISE_IMAGES.filter(e => e.group === clean);
}
